import { createFileRoute } from '@tanstack/react-router'
import { AdminProjectsImport } from '../features/admin'
import { currentUserQuery, projectsImportQuery } from '../features/admin/queries'
import { adminRouteState } from '../features/admin/route-state'

export const Route = createFileRoute('/admin/projects-import')({
  ...adminRouteState,
  loader: async ({ context }) => {
    await context.queryClient.ensureQueryData(currentUserQuery())
    return context.queryClient.ensureQueryData(projectsImportQuery())
  },
  component: AdminProjectsImport,
})
